const StyledInput = (props: any) => {
  return (
    <input
      {...props}
      style={{
        padding: 12,
        fontSize: 18,
        border: 0,
        textAlign: "center",
        borderRadius: 100,
        ...props.style,
      }}
    />
  );
};

export default StyledInput;
